import type { CessionFinancingStatusEnum, CessionStatusEnum, PaymentStatusEnum } from '../services/capitalMarketsService';

export const FINANCING_STATUS_LABELS: Record<CessionFinancingStatusEnum, string> = {
  awaiting_black_endorsement_generation: 'Aguardando Geração de Endosso em Preto',
  awaiting_endorsement_signatures: 'Aguardando Assinaturas do Endosso',
  awaiting_return_cession_intermediator: 'Aguardando Retorno da Cessão do Intermediador',
  backing_sent: 'Lastro Enviado',
  cancelled_by_user: 'Cancelado pelo Usuário',
  cession_cancelled_by_intermediator: 'Cessão Cancelada pelo Intermediador',
  done: 'Concluído',
  failed_backing_not_found: 'Falha Lastro Não Encontrado',
  failed_send_backing: 'Falha ao Enviar Lastro',
  failure_import_installments: 'Falha na Importação de Parcelas',
  failure_send_cession_intermediator: 'Falha ao Enviar Cessão ao Intermediador',
  generating_endorsement_black: 'Gerando Endosso em Preto',
  in_progress: 'Em Andamento',
  invalidated_by_intermediator: 'Invalidado pelo Intermediador',
  pending_send_intermediator: 'Pendente de Envio ao Intermediador',
  sending_backing: 'Enviando Lastro',
  sending_cession_intermediator: 'Enviando Cessão ao Intermediador',
  signed: 'Assinado',
  synced_installments: 'Parcelas Sincronizadas',
  waiting_import_installments: 'Aguardando Importação de Parcelas',
};

export const CESSION_STATUS_LABELS: Record<CessionStatusEnum, string> = {
  awaiting_black_endorsement_generation: 'Aguardando Geração de Endosso em Preto',
  awaiting_return_cession_intermediator: 'Aguardando Retorno de Cessão do Intermediador',
  cancelled_by_user: 'Cancelado pelo Usuário',
  cession_cancelled_by_intermediator: 'Cessão Cancelada pelo Intermediador',
  changed_securitization: 'Securitização Alterada',
  done: 'Concluído',
  endorsement_black_sent_for_signature: 'Endosso em Preto Enviado para Assinatura',
  failed_import_financing: 'Falha na Importação de Financiamento',
  failed_import_installments: 'Falha na Importação de Parcelas',
  failed_intermediator: 'Falha no Intermediador',
  generating_endorsement_black: 'Gerando Endosso em Preto',
  in_creation: 'Em Criação',
  in_progress: 'Em Andamento',
  invalidated_by_intermediator: 'Invalidado pelo Intermediador',
  partially_done: 'Parcialmente Concluído',
  pending_send_intermediator: 'Pendente de Envio ao Intermediador',
  sending_backing: 'Enviando Garantia',
  sending_cession_intermediator: 'Enviando Cessão ao Intermediador',
  sync_installments: 'Sincronizando Parcelas',
  synced_installments: 'Parcelas Sincronizadas',
};

export function getCessionStatusLabel(status: CessionStatusEnum): string {
  return CESSION_STATUS_LABELS[status] || status;
}

export function getFinancingStatusLabel(status: CessionFinancingStatusEnum): string {
  return FINANCING_STATUS_LABELS[status] || status;
}

export const PAYMENT_STATUS_LABELS: Record<PaymentStatusEnum, string> = {
  completed: 'Completo',
  failed: 'Falhou',
  not_applicable: 'Não Aplicável',
  pending: 'Pendente',
};

export function getPaymentStatusLabel(status: PaymentStatusEnum): string {
  return PAYMENT_STATUS_LABELS[status] || status;
}
